const e = {
  followUs: {
    ar: {
      label: "تابع تأميني"
    },
    en: {
      label: "Follow Tameeni"
    }
  },
  productLinks: {
    en: {
      title: "Products",
      CarInsurance: "Car Insurance",
      HealthInsurance: "Health Insurance",
      TravelInsurance: "Travel Insurance",
      DomesticHelperInsurance: "Domestic Helper Insurance",
      MedicalMalpracticeInsurance: "Medical Malpractice Insurance"
    },
    ar: {
      title: "المنتجات",
      CarInsurance: "تأمين السيارات",
      HealthInsurance: "التأمين الصحي للشركات الصغيرة والمتوسطة",
      TravelInsurance: "تأمين السفر",
      DomesticHelperInsurance: "التأمين الطبي للعمالة المنزلية",
      MedicalMalpracticeInsurance: "تأمين الأخطاء الطبية"
    }
  },
  supportLinks: {
    en: {
      title: "Support",
      ContactUs: "Contact Us",
      PrivacyPolicy: "Privacy Policy",
      TermsConditions: "Terms & Conditions",
      CustomerCareNumber: "Customer Care Number"
    },
    ar: {
      title: "الدعم",
      ContactUs: "اتصل بنا",
      PrivacyPolicy: "سياسة الخصوصية",
      TermsConditions: "الشروط والأحكام",
      CustomerCareNumber: "رقم خدمة العملاء"
    }
  },
  resourceLinks: {
    en: {
      title: "Resources",
      FAQs: "FAQ's",
      CentralBankPublications: "Central Bank Publications",
      Careers: "Careers",
      Partners: "Partners"
    },
    ar: {
      title: "الموارد",
      FAQs: "الأسئلة الشائعة",
      CentralBankPublications: "منشورات البنك المركزي",
      Careers: "الوظائف",
      Partners: "الشركاء"
    }
  }
};
export {
  e as footerTranslations
};
//# sourceMappingURL=translation.js.map
